import { Injectable, inject } from '@angular/core';
import { LoggerService } from '@pf/shared-services';
import {
    AbstractTypeEntityFacade,
    TypeEntityStore,
} from '@pf/shared/util-platform';
import { LoadStatusTypesService } from '@control-tower/platform-loads';
import { TypeEntityTypes } from '@pf/shared-common';

@Injectable()
export class LoadStatusTypeFacade extends AbstractTypeEntityFacade<LoadStatusTypesService> {
    constructor() {
        const typeService = inject(LoadStatusTypesService);
        const store = inject(TypeEntityStore);
        const logger = inject(LoggerService);

        super(
            store,
            logger,
            typeService,
            'loadStatusTypeGetAll',
            TypeEntityTypes.LoadStatusType
        );
    }
}
